import { useEffect } from "react";
import { useTranslation } from "react-i18next";
// import Select from "react-select";
// import { obtenerListaEmpresaPlataforma } from "../api/api-empresa-plataforma";

export default function ModalFormSeller({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);

        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        codigo: 64,
        nombre: 64,
        nota: 128,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            let message = "";
            if (String(formData.nombre).trim().length === 0) {
                message = message + t("alert_must_enter_name") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            codigo: "",
            nombre: "",
            nota: "",
        });
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white sm:p-2 md:p-4 lg:p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
                        {/* </div>
                        <div className="rounded-lg w-1/2">
                        </div> */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("code")}</label>
                            <input
                                name="codigo"
                                value={formData.codigo}
                                onChange={handleInputChange}
                                placeholder={t("enter_code")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_nombre_vendedor")}<span className="text-red-500">*</span></label>
                            <input
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                placeholder={t("enter_name")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("note")}</label>
                            <textarea
                                name="nota"
                                value={formData.nota}
                                onChange={handleInputChange}
                                placeholder={t("enter_note")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                                rows={3}
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nota.length}/{charLimits.nota}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
